import React from "react";
import { Stack } from "@mui/system";
import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";



export default function Paragominas(){

  return(

    <>
    <Helmet title="Paragominas - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="PARAGOMINAS" link1={"Projetos/ "} link2={"PARAGOMINAS"} />
      <section id="context">
        <div className="container">

        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                    Paragominas
                </h2>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Prestação de serviços gerais de suporte à topografia de mina, manuseio e transporte de amostras de testemunho de sondagem, serviços de coleta, preparação física e transporte das amostras de BAUXITA ao laboratório na Mina de Bauxita da Hydro Paragominas – PA.
                </p>
              </div>
            </div>

            <div className="context-box context-info"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0"
            >
                <h2>Informações do Projeto</h2>
                <ul>
                  <li><strong>Cliente: </strong> Mineração Paragominas</li>
                  <li><strong>Cidade: </strong> Paragominas - PA </li>
                  <li><strong>Ano: </strong> 2018 </li>
                  <li><strong>Segmento: </strong> Topografia e Engª Civil </li>
                </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />

      <Ouvidoria/>
    </>
  )
}